export const CONSOLE_LOG = process.env.REACT_APP_ENV !== 'PRODUCTION' ? true : false;
export const URL = process.env.REACT_APP_HOST_COMPANIES_URL;
export const URLsmall = process.env.REACT_APP_HOST_URL;
export const urlBuilder = process.env.REACT_APP_HOST_BUILDER_URL;
export const loginBuilder = process.env.REACT_APP_HOST_LOGIN_BUILDER_URL;
export const urlImg = process.env.REACT_APP_HOST_IMGS_URL;

// si no estoy en localhost uso el de la url, si estoy en local le adjunto el domain de la company en mi env local

//let domain = "";
//switch (process.env.REACT_APP_ENV){
//      case "PROD":
let domain = window.location.host; //.split(".").slice(1).join(".");
//              break;
//      default: // dev, local y staging... solo dame el subdominio
//              domain = window.location.host.split(".")[0];
//              break;
//}

export const LONG_URL = process.env.REACT_APP_HOST_COMPANY_URL + domain;
console.log(LONG_URL);



// xq debo hacer esto ?  -.-
export const ENV2 = process.env.REACT_APP_ENV;



// WEBPACK FOOTER //
// ./src/config.js